import React, { ReactNode } from 'react';
import { WprFramework } from '../../wpr-framework/WprFramework';
import { WprSettingInfo } from '../../wpr-framework/WprSettingInfo';
import { WprValueMapSetter } from '../../wpr-framework/model/WprValueMapSetter';
import { WprScopeSetter } from '../../wpr-framework/scope/WprScopeSetter';
import { WprValidatorSetter } from '../../wpr-framework/view/validation/WprValidatorSetter';
import { WprAuthoritySetter } from '../../wpr-framework/authority/WprAuthoritySetter';
import { WprValueMap } from '../../wpr-framework/model/WprValueMap';
import { CreditExpireValueMap } from './ValueMap/CreditExpireValueMap';
import { NationValueMap } from './ValueMap/NationValueMap';
import { GlobalScopeInfo } from '../../scope/GlobalScopeInfo';
// import { PersonValueMap } from './ValueMap/PersonValueMap';
import { DateValueMap } from './ValueMap/DateValueMap';
import { PrefecturesValueMap } from './ValueMap/PrefecturesValueMap';
import { FirstScopeInfo } from '../../scope/FirstScopeInfo';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { PersonValueMap } from './ValueMap/PersonValueMap';
import { WprConverterSetter } from '../../wpr-framework/view/convert/WprConverterSetter';
import { WprGenderConverter } from '../../wpr-framework/view/convert/converter/WprGenderConverter';
import { PostalCodeConverter } from './Converter/PostalCodeConverter';
import { WprBaseFrameworkComponent } from '../../wpr-framework/component/base/WprBaseFrameworkComponent';
import { CreditCardNameValidator } from './Validator/CreditCardNameValidator';
import { PassAvailableCharacterValidator } from './Validator/PassAvailableCharacterValidator';
import { PassCombinationValidator } from './Validator/PassCombinationValidator';

/**
 * フレームワークコンポーネント
 */
export class FrameworkComponent extends WprBaseFrameworkComponent {
	// override メソッド  --------------------------------------------------------
	/**
	 * WprFramework設定処理
	 * @param setter 設定情報
	 */
	onSetting(settingInfo: WprSettingInfo): void {
		// settingInfo.logLevel = WprLogLevel.DEBUG;
		const framework: WprFramework = WprFramework.getInstance();
		const urlParamMap = this.getParamMap(window.location.search);
		for(let [key, value] of urlParamMap)
			framework.setUrlParam(key, value);
		// if (urlParamMap.size === 0) {
		// 	framework.setUrlParam('product', 'OTA');
		// 	framework.setUrlParam('agentcode', '20393');
		// }
	}

	/**
	 * ValueMap設定処理
	 * @param vmSetter ValueMapセッター
	 */
	public onRegisterValueMap(vmSetter: WprValueMapSetter): void {
		// NationValueMap.addValueMap(vmSetter);
		CreditExpireValueMap.addValueMap(vmSetter);
		PersonValueMap.addValueMap(vmSetter);
		DateValueMap.addValueMap(vmSetter);
		PrefecturesValueMap.addValueMap(vmSetter);
	}

	/**
	 * バリデータ設定処理
	 * @param validSetter ValueMapセッター
	 */
	public onRegisterValidator(validSetter: WprValidatorSetter): void {
		validSetter.addValidator(new PassAvailableCharacterValidator());
		validSetter.addValidator(new PassCombinationValidator());
		validSetter.addValidator(new CreditCardNameValidator());
		validSetter.setCustomMessage('必須', '%desc%を入力してください');
		validSetter.setCustomMessage('全角', '全角で入力してください');
		validSetter.setCustomMessage('半角英字', '半角英字で入力してください');
		validSetter.setCustomMessage('パスワード使用可能文字', 'パスワードは半角英数で入力してください');
		validSetter.setCustomMessage('パスワード組み合わせ', 'パスワードには大文字英字、小文字英字、数字、記号から2種類以上を使用してください');
		validSetter.setCustomMessage('クレジットカード名義', '%desc%は半角英大文字で入力してください');
	}

	/**
	 * コンバータ設定処理
	 * @param convertSetter ValueMapセッター
	 */
	public onRegisterConverter(convertSetter: WprConverterSetter): void {
		convertSetter.addConverter(new PostalCodeConverter());
	}

	/**
	 * スコープ情報登録
	 * @param validSetter ValueMapセッター
	 */
	public onRegisterScope(scopeSetter: WprScopeSetter): void {
		scopeSetter.addScope(new GlobalScopeInfo());
		scopeSetter.addScope(new FirstScopeInfo());
		scopeSetter.addScope(new SecondScopeInfo());
	}

	/**
	 * 権限設定処理
	 * @param authoritySetter 権限セッター
	 */
	public onRegisterAuthority(authoritySetter: WprAuthoritySetter): void {}
	// --------------------------------------------------------------------------

	// private メソッド  --------------------------------------------------------
	/**
	 * urlパラメータマップ取得
	 * @param value 
	 * @returns URLパラメータマップ
	 */
	private getParamMap(value: string){
		let urlParamStr = value.substring(1);
		let paramMap = new Map();
		urlParamStr.split('&').forEach( param => {
			for(let i=0; i<param.length; i++){
				const temp = param.split('=');
				paramMap.set(temp[0], temp[1]);
			}
		});
		return paramMap;
	}
	// --------------------------------------------------------------------------
}
